module.exports = __webpack_public_path__ + "media/images/icons/material/behance-fbf7d7df37171abb2db4aa7ec95d7cc8.svg";